import { ajax } from '../index'

/**
 * supplier 相关接口
 */
export default {
  // 提交Supplier 表单数据
  submitSupplier(dataObj: any) {
    return ajax.post('api', `/api/v1/supplier/email`, dataObj)
  }
}